export default "__VITE_ASSET__1399ab30__"